import {
    DataCollectionResource,
    DataCondition,
    DataGranularityKey,
    DataType,
    PartialDataset,
} from '@portal/common/types';

export const getDatasetsPrimaryEntityFilterKeys = (
    dataCollection: DataCollectionResource | null | undefined,
    dataTypes: DataType[] | null | undefined
): DataGranularityKey[] =>
    (dataCollection?.datasets || [])
        .filter(({ data_type }) => (dataTypes || []).includes(data_type))
        .map(({ primary_entity_id_filter }) => primary_entity_id_filter);

export const getDatasetConditions = (dataset: PartialDataset): DataCondition[] => {
    const { data_type, granularity, primary_entity_id_filter } = dataset;

    return granularity && granularity[primary_entity_id_filter]
        ? (granularity[primary_entity_id_filter] || []).map((primary_entity_id) => ({
              data_type,
              primary_entity_id,
          }))
        : [];
};
